export const STRIPE_PUBLISHABLE_KEY = process.env.REACT_APP_STRIPE_KEY || "";

// Lazily load the Stripe.js script, then return a Stripe() instance.
// Instances are cached per connected-account so we can bind to an
// operator's Connect account for DIRECT charges (Phase E.2): a card
// tokenized with { stripeAccount } belongs to that operator's account,
// which is required for create-customer to attach it there.
//   loadStripe()            -> platform account (legacy / default org)
//   loadStripe(acct_123…)   -> the operator's connected account
const instances = {};
async function ensureScript() {
  if (window.Stripe) return;
  await new Promise((res, rej) => {
    if (document.querySelector('script[src*="stripe"]')) { res(); return; }
    const s = document.createElement("script");
    s.src = "https://js.stripe.com/v3/";
    s.onload = res; s.onerror = rej;
    document.head.appendChild(s);
  });
}
export async function loadStripe(stripeAccount) {
  const key = stripeAccount || "_platform";
  if (instances[key]) return instances[key];
  await ensureScript();
  instances[key] = stripeAccount
    ? window.Stripe(STRIPE_PUBLISHABLE_KEY, { stripeAccount })
    : window.Stripe(STRIPE_PUBLISHABLE_KEY);
  return instances[key];
}
